/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Box } from "~/components/Styled/Box";
import { COLORS } from "./constants";

type Props = {
  value: string;
  onChange: (value: string) => void;
};

export function ColorPicker({ value, onChange }: Props) {
  return (
    <>
      {COLORS.map((color: string) => (
        <Box
          key={color}
          inline
          color={color}
          margin=".25rem"
          size="1.75rem"
          onClick={() => {
            onChange(color);
          }}
          css={{
            opacity: value === color ? 1 : 0.3,
          }}
        />
      ))}
    </>
  );
}
